import * as React from "react";

function SvgBellDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M12.014 3.375l.236.005a6.374 6.374 0 016.12 6.137l.005.233v3.484l1.06 1.059c.426.428.7.98.786 1.587l.021.204.007.208-.007.179a2.674 2.674 0 01-2.5 2.461l-.167.006h-2.503a3.08 3.08 0 01-2.868 2.805L12 21.75a3.086 3.086 0 01-3.072-2.813H6.424a2.68 2.68 0 01-2.67-2.535l-.004-.173.01-.212a2.796 2.796 0 01.657-1.565l.148-.16 1.059-1.059V9.75a6.376 6.376 0 015.915-6.359l.231-.012.243-.004zm1.547 15.563h-3.122a1.581 1.581 0 001.403 1.304l.156.008a1.584 1.584 0 001.563-1.312zM23 8.25a.75.75 0 01.102 1.493L23 9.75h-1.979a.75.75 0 01-.101-1.493l.101-.007H23zm-20.021 0a.75.75 0 01.101 1.493l-.101.007H1a.75.75 0 01-.102-1.493L1 8.25h1.979zm19.666-5.666a.75.75 0 01-.12.972l-.088.068-2 1.333a.75.75 0 01-.92-1.179l.088-.069 2-1.333a.75.75 0 011.04.208zM2.298 2.321l.097.055 2 1.333a.75.75 0 01-.736 1.303l-.096-.055-2-1.333a.75.75 0 01.735-1.303z"
        />
        <path
          fill="#98DB69"
          d="M12 4.875l.206.004c2.596.1 4.669 2.25 4.669 4.871v3.795c0 .199.08.39.22.53l1.279 1.278c.24.241.376.569.376.91l-.005.121c-.046.58-.555 1.053-1.17 1.053H6.425c-.65 0-1.175-.525-1.175-1.174l.007-.146c.025-.268.156-.55.37-.764l1.278-1.277a.755.755 0 00.22-.531V9.75A4.875 4.875 0 0112 4.875z"
        />
      </g>
    </svg>
  );
}

export default SvgBellDuo;
